// Simple Stripe API integration using user's restricted API key

const getFunctionUrl = (functionName) => {
  if (process.env.NODE_ENV === 'production') {
    return `/.netlify/functions/${functionName}`;
  }
  return `http://localhost:8888/.netlify/functions/${functionName}`;
};

export const saveStripeApiKey = async (email, apiKey) => {
  const response = await fetch(getFunctionUrl('stripe-save-key'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, apiKey }),
  });

  if (!response.ok) {
    throw new Error('Failed to save API key');
  }

  return response.json();
};

export const hasStripeApiKey = async (email) => {
  const response = await fetch(`${getFunctionUrl('stripe-key-status')}?email=${encodeURIComponent(email)}`);

  if (!response.ok) {
    return false;
  }

  const data = await response.json();
  return data.hasKey || false;
};

export const removeStripeApiKey = async (email) => {
  const response = await fetch(getFunctionUrl('stripe-remove-key'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    throw new Error('Failed to remove API key');
  }

  return response.json();
};

export const checkCustomerSubscription = async (userEmail, customerEmail) => {
  const response = await fetch(
    `${getFunctionUrl('stripe-check-subscription')}?userEmail=${encodeURIComponent(userEmail)}&customerEmail=${encodeURIComponent(customerEmail)}`
  );

  if (!response.ok) {
    throw new Error('Failed to check subscription');
  }

  return response.json();
};

export const checkCustomerDetails = async (userEmail, customerEmail) => {
  const response = await fetch(getFunctionUrl('stripe-check-customer'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ userEmail, customerEmail }),
  });

  if (!response.ok) {
    throw new Error('Failed to check customer details');
  }

  return response.json();
};

export const cancelStripeSubscription = async (userEmail, subscriptionId, cancelAtPeriodEnd) => {
  const response = await fetch(getFunctionUrl('stripe-cancel-subscription'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ userEmail, subscriptionId, cancelAtPeriodEnd }),
  });

  if (!response.ok) {
    throw new Error('Failed to cancel subscription');
  }

  return response.json();
};

export const createStripeRefund = async (userEmail, chargeId, paymentIntentId, amount) => {
  const response = await fetch(getFunctionUrl('stripe-refund'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userEmail,
      chargeId,
      paymentIntentId,
      amount,
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to create refund');
  }

  return response.json();
};
